var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShieldRounded = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 13.88c-.071 0-.146-.007-.224-.02a1.095 1.095 0 0 1-.218-.058c-1.531-.584-2.748-1.573-3.65-2.968-.902-1.396-1.353-2.906-1.353-4.532V2.971c0-.264.076-.504.23-.718a1.32 1.32 0 0 1 .586-.467L6.56.231C6.71.176 6.858.148 7 .148c.14 0 .287.028.44.083l4.187 1.555c.238.097.434.253.587.467.153.214.23.454.23.718v3.331c0 1.626-.452 3.136-1.354 4.532-.902 1.395-2.119 2.384-3.65 2.968A1.365 1.365 0 0 1 7 13.88Z",
    fill: "#9999AC"
  })));
};
export default SvgShieldRounded;